<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-bar class="search-bar" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<program-table :scrId="scrId" />
			</div>
		</div>
		<program-registration-popup :scrId="scrId" />
	</div>
</template>

<script>
import { SearchBar } from './Search';
import { ProgramTable } from './Table';
import { ProgramRegistrationPopup } from './ProgramRegistrationPopup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchBar,
		ProgramTable,
		ProgramRegistrationPopup
	}
};
</script>

<style></style>
